var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeature1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 677,
    height: 312,
    viewBox: "0 0 677 312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Feature-1-svg-a",
    x: 0,
    y: 0,
    width: 224,
    height: 312,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4f4e74",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Feature-1-svg-c",
    x: 453,
    y: 0,
    width: 224,
    height: 312,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4f4e74",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Feature-1-svg-e",
    x: 240,
    y: 40,
    width: 197,
    height: 233,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "f"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4f4e74",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 10)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -12, -10)",
    filter: "url(#Feature-1-svg-a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 288,
    rx: 8,
    transform: "translate(12 10)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(52.545 22)",
    fill: "#4f4e74",
    fontSize: 16,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 23.951,
    y: 17
  }, "Loan 1")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(82 111)",
    fill: "#4135af",
    fontSize: 40,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 43
  }, "[")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(56 175)",
    fill: "#4135af",
    fontSize: 40,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 43
  }, "[")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(132 111)",
    fill: "#4135af",
    fontSize: 40,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 43
  }, "]")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(106 175)",
    fill: "#4135af",
    fontSize: 40,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 43
  }, "]")), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 152,
    rx: 6,
    transform: "translate(176 72.197) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 152,
    rx: 6,
    transform: "translate(176 104) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 52,
    rx: 6,
    transform: "translate(76 136) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 52,
    rx: 6,
    transform: "translate(176 200) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 26,
    rx: 6,
    transform: "translate(176 136) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 152,
    rx: 6,
    transform: "translate(176 168) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 26,
    rx: 6,
    transform: "translate(50 200) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 152,
    rx: 6,
    transform: "translate(176 232) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(453)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -465, -10)",
    filter: "url(#Feature-1-svg-c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 288,
    rx: 8,
    transform: "translate(465 10)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(52 22)",
    fill: "#4f4e74",
    fontSize: 16,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 23.951,
    y: 17
  }, "Loan 2")), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 152,
    rx: 6,
    transform: "translate(176 72.197) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 152,
    rx: 6,
    transform: "translate(176 104) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 152,
    rx: 6,
    transform: "translate(176 136) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 52,
    rx: 6,
    transform: "translate(76 168) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 152,
    rx: 6,
    transform: "translate(176 200) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(82 142)",
    fill: "#4135af",
    fontSize: 40,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 43
  }, "[")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(132 142)",
    fill: "#4135af",
    fontSize: 40,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 43
  }, "]")), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 152,
    rx: 6,
    transform: "translate(176 232) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 26,
    rx: 6,
    transform: "translate(176 168) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240 40)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -252, -50)",
    filter: "url(#Feature-1-svg-e)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 173,
    height: 209,
    rx: 8,
    transform: "translate(252 50)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(29 22)",
    fill: "#4f4e74",
    fontSize: 16,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 10.928,
    y: 17
  }, "Transferability")), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 96,
    rx: 3.5,
    transform: "translate(148.5 80.5) rotate(90)",
    fill: "#d6e3ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 96,
    rx: 3.5,
    transform: "translate(148.5 116.5) rotate(90)",
    fill: "#d6e3ff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24 74)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "none",
    stroke: "#d6e3ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(3 3)",
    fill: "#04be9d"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24 110)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "none",
    stroke: "#d6e3ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 96,
    rx: 3.5,
    transform: "translate(148.5 152.5) rotate(90)",
    fill: "#d6e3ff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24 146)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "none",
    stroke: "#d6e3ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(3 3)",
    fill: "#04be9d"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M0,0,120,28",
    transform: "translate(113 142)",
    fill: "none",
    stroke: "#4135af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,21,145,0",
    transform: "translate(88 186)",
    fill: "none",
    stroke: "#4135af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,.5H0",
    transform: "translate(420 173.5)",
    fill: "none",
    stroke: "#4135af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.48
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature1);
export default __webpack_public_path__ + "static/media/feature1.223813066689d4f30a9ab461346f7322.svg";
export { ForwardRef as ReactComponent };